function Cowork() {
    return (
      <div className='w100p h500 jcC aiC dpFlx bgcBlueviolet'>
          <span className='fcWhite fs50'>협력업체 내용이 들어갈 영역입니다.</span>
      </div>
    )
  }
  export default Cowork